import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withSetsSearch from '../../common/withSetsSearch';
import withPreference from '../../common/withPreference';
import withOnline from '../../common/withOnline';
import Header from '../../components/Header';
import PreferenceSetsList from './PreferenceSetsList';
import { onGoBack } from '../../common/globals';
import SetContents from '../../components/Sets/SetContents';
import Components from '../../components/ManageCase/Components';
import SetsMasterGroup from '../../components/ManageCase/SetsMasterGroup';
import SaveSetsModal from '../../components/Models/SaveSetsModal';
import ACMProductGoBackModal from '../../components/Models/ACMProductGoBackModal';
import Bugsnag from '../../helpers/bugsnag';

class AddPreferenceSets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isComponent: false,
      selectedComponent: '',
      isSetContents: false,
      isGroup: false,
      selectedGroup: '',
      caseDetail: {},
      longPressItem: null,
      selectedSetsCount: 0,
      selectedSets: [], // This is save temp only
    };
    this.saveSets = null;
    this.preferenceBackModal = null;
    this._onChildSetsSave = null;
  }

  componentDidMount() {
    try {
      this.saveSets = new window.bootstrap.Modal(
        window.$('#saveSetsModal')
      );
      this.preferenceBackModal = new window.bootstrap.Modal(
        window.$('#acmProductGoBackModal')
      );
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedComponent = (selectedComponent) => {
    try {
      const { isComponent } = this.state;
      if (selectedComponent.Component !== '') {
        this.setState({
          selectedComponent, isComponent: !isComponent
        });
      } else {
        this.setState({
          selectedComponent: '', isComponent: !isComponent
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickComponent = () => {
    try {
      const { isComponent, selectedComponent } = this.state;
      if (selectedComponent.Component === undefined) {
        this.setState({
          isComponent: !isComponent
        });
      } else {
        this.setState({
          selectedComponent: ''
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedSetsGroup = (selectedGroup) => {
    try {
      const { isGroup } = this.state;
      if (selectedGroup.SetGroup !== '') {
        this.setState({
          selectedGroup,
          isGroup: !isGroup
        });
      } else {
        this.setState({
          selectedGroup: '',
          isGroup: !isGroup
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickGroup = () => {
    try {
      const { isGroup, selectedGroup } = this.state;
      if (selectedGroup === '') {
        this.setState({
          isGroup: !isGroup
        });
      } else {
        this.setState({
          selectedGroup: ''
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onComponentBack = () => {
    try {
      const { isComponent } = this.state;
      this.setState({
        isComponent: !isComponent
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGroupBack = () => {
    try {
      this.setState({ isGroup: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetContentBack = () => {
    try {
      this.setState({ isSetContents: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSave = async () => {
    try {
      const {
        online, notify, setSetsSearch
      } = this.props;

      setSetsSearch({});
      this._onChildSetsSave(async (selectedSets) => {
        if (!online) {
          notify({
            type: 'warning',
            message: 'You must have as internet connection. Please check your connection and try again.',
            time: 3
          });
        }
        let selectedSetsCount = 0;

        selectedSets = selectedSets.map(({ Quantity, DeviceType, SetName }) => {
          selectedSetsCount += Number(Quantity);
          return {
            Quantity,
            DeviceType,
            SetName
          };
        });

        this.setState({ selectedSetsCount, selectedSets }, () => {
          this.saveSets.show();
        });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetBack = () => {
    try {
      const { goBack, setSetsSearch } = this.props;
      /* this._onChildSetsSave(async (selectedSets) => {
        selectedSets = selectedSets.map(
          ({ Quantity, DeviceType, SetName }) => ({ Quantity, DeviceType, SetName })
        );
        this.setState({ selectedSets });
        if (JSON.stringify(selectedSets) !== JSON.stringify(preference.selectedSets)) {
          this.preferenceBackModal.show();
        } else {
          onGoBack(goBack);
          setSetsSearch({});
        }
      }); */
      onGoBack(goBack);
      setSetsSearch({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetsSave = () => {
    try {
      const {
        setPreference, preference, goBack
      } = this.props;
      const { selectedSets } = this.state;
      preference.selectedSets = selectedSets.filter(({ Quantity }) => Quantity > 0);
      setPreference(preference);
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetLongPress = (item) => {
    try {
      this.setState({ isSetContents: true, longPressItem: item });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBackCancel = () => {
    try {
      const { goBack, setSetsSearch } = this.props;
      setSetsSearch({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      isComponent, isSetContents, selectedComponent, id, isGroup,
      selectedGroup, longPressItem, selectedSetsCount
    } = this.state;
    const { preference } = this.props;
    return (
      <section className="list-section">
        <Header
          actionButton={
            (isComponent || isGroup || isSetContents)
              ? ''
              : { title: 'Add', onClick: this._onSave }
          }
          title={
            isComponent
              ? 'Components'
              : isGroup
                ? 'Groups'
                : isSetContents
                  ? 'Set Contents'
                  : 'Sets'
          }
          goBack={
            isComponent
              ? this._onComponentBack
              : isGroup
                ? this._onGroupBack
                : isSetContents
                  ? this._onSetContentBack
                  : this._onSetBack
          }
        />
        {(isSetContents
          ? (
            <SetContents
              setName={longPressItem.SetName}
              setType="officeset"
            />
          )
          : isComponent ? (
            <Components
              onSelectedComponent={this._onSelectedComponent}
              caseType={preference.CaseType}
            />
          )
            : isGroup ? (
              <SetsMasterGroup
                onSelectedSetsGroup={this._onSelectedSetsGroup}
                caseType={preference.CaseType}
              />
            )
              : (
                <PreferenceSetsList
                  setChildSetsSave={(fun) => { this._onChildSetsSave = fun; }}
                  id={id}
                  isPastRec={false}
                  showHeaderButton={false}
                  isSetContents={isSetContents}
                  onSetLongPress={this._onSetLongPress}
                  selectedComponent={selectedComponent}
                  onClickComponent={this._onClickComponent}
                  selectedGroup={selectedGroup}
                  onClickGroup={this._onClickGroup}
                  caseTypePreferenceValue={preference.CaseType}
                />
              )
        )}
        <SaveSetsModal
          selectedSetsCount={selectedSetsCount}
          onSave={this._onSetsSave}
        />

        <ACMProductGoBackModal
          onSave={this._onSave}
          onCancel={this._onBackCancel}
        />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'AddPreferenceSetsForm',
});

export default withSetsSearch(
  withOnline(
    withPreference(
      withForm(
        withGoBack(
          withNotify(
            withLoader(
              AddPreferenceSets
            )
          )
        )
      )
    )
  )
);
